var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerTimedOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "200px",
    viewBox: "0 0 300 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "server-timed-out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 83,
    y: 67,
    width: 124,
    height: 121
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 124,
    height: 121,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 81.5,
    cy: 164.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-5",
    cx: 95.5,
    cy: 164.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-7",
    cx: 109.5,
    cy: 164.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 208.5,
    cy: 164.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-11",
    cx: 208.5,
    cy: 178.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83,85 C83,82.2385763 85.241364,80 88.0022625,80 L132.997738,80 C135.760411,80 138,82.2441952 138,85 L138,90 L83,90 L83,85 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 55,
    height: 10,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-15",
    cx: 81.5,
    cy: 74.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-17",
    cx: 95.5,
    cy: 74.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-19",
    cx: 109.5,
    cy: 74.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-21",
    cx: 208.5,
    cy: 74.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-23",
    cx: 208.5,
    cy: 88.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83,93 C83,89.1340068 86.1345754,86 89.9936988,86 L131.006301,86 C134.868814,86 138,89.1418733 138,93 L138,100 L83,100 L83,93 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 55,
    height: 14,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-27",
    cx: 81.5,
    cy: 119.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-29",
    cx: 95.5,
    cy: 119.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-31",
    cx: 109.5,
    cy: 119.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-33",
    cx: 208.5,
    cy: 119.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-35",
    cx: 208.5,
    cy: 133.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-37",
    cx: 195.5,
    cy: 119.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-39",
    cx: 195.5,
    cy: 133.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-41",
    cx: 181.5,
    cy: 119.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-43",
    cx: 181.5,
    cy: 133.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-45",
    cx: 195.5,
    cy: 164.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-47",
    cx: 195.5,
    cy: 178.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-48",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-47"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-49",
    cx: 181.5,
    cy: 164.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-50",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-49"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-51",
    cx: 181.5,
    cy: 178.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-52",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-51"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83,138 C83,134.134007 86.1345754,131 89.9936988,131 L131.006301,131 C134.868814,131 138,134.141873 138,138 L138,145 L83,145 L83,138 Z",
    id: "path-53"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-54",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 55,
    height: 14,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-53"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83,183 C83,179.134007 86.1345754,176 89.9936988,176 L131.006301,176 C134.868814,176 138,179.141873 138,183 L138,190 L83,190 L83,183 Z",
    id: "path-55"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-56",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 55,
    height: 14,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-55"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-57",
    cx: 222,
    cy: 62,
    r: 30
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-58",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-57"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-59",
    x: 221,
    y: 47,
    width: 2,
    height: 17,
    rx: 1
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-60",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 17,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-59"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-61",
    x: 214.126793,
    y: 60.4077635,
    width: 2,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-62",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 16,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-61"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-63",
    cx: 222,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-64",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: -2,
    y: -2,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 58,
    width: 12,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-63",
    fill: "black"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "server-timed-out"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#787878",
    x: 15,
    y: 188,
    width: 270,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,149.5 C143,147.886304 143.177513,146.296463 143.525977,144.750248 C143.647398,144.211476 143.309068,143.676284 142.770296,143.554863 C142.231524,143.433442 141.696332,143.771772 141.574911,144.310544 C141.193978,146.000829 141,147.738133 141,149.5 C141,150.052285 141.447715,150.5 142,150.5 C142.552285,150.5 143,150.052285 143,149.5 Z M145.0912,140.237194 C145.780284,138.795773 146.628753,137.435905 147.619121,136.182373 C147.961498,135.749018 147.887746,135.120163 147.454391,134.777786 C147.021037,134.435409 146.392182,134.509161 146.049805,134.942516 C144.96752,136.312388 144.040134,137.79874 143.28679,139.37458 C143.048585,139.872854 143.259414,140.469888 143.757688,140.708092 C144.255962,140.946296 144.852996,140.735468 145.0912,140.237194 Z M150.977421,132.78345 C152.218794,131.778181 153.56821,130.913368 155.000973,130.206798 C155.4963,129.962525 155.699821,129.362961 155.455549,128.867633 C155.211277,128.372306 154.611712,128.168785 154.116385,128.413057 C152.550117,129.185466 151.075281,130.130658 149.718761,131.229174 C149.289559,131.576743 149.223383,132.20644 149.570953,132.635642 C149.918522,133.064844 150.548219,133.13102 150.977421,132.78345 Z M159.568138,128.568759 C161.111467,128.206617 162.699693,128.015073 164.312953,128.000855 C164.865216,127.995987 165.308968,127.544344 165.304101,126.992081 C165.299234,126.439817 164.84759,125.996065 164.295327,126.000932 C162.53389,126.016456 160.79835,126.225767 159.111249,126.621645 C158.573568,126.747812 158.23997,127.285967 158.366137,127.823647 C158.492303,128.361328 159.030458,128.694926 159.568138,128.568759 Z M169.379203,128 L174.379203,128 C174.931488,128 175.379203,127.552285 175.379203,127 C175.379203,126.447715 174.931488,126 174.379203,126 L169.379203,126 C168.826918,126 168.379203,126.447715 168.379203,127 C168.379203,127.552285 168.826918,128 169.379203,128 Z M179.379203,128 L184.379203,128 C184.931488,128 185.379203,127.552285 185.379203,127 C185.379203,126.447715 184.931488,126 184.379203,126 L179.379203,126 C178.826918,126 178.379203,126.447715 178.379203,127 C178.379203,127.552285 178.826918,128 179.379203,128 Z M189.379203,128 L194.379203,128 C194.931488,128 195.379203,127.552285 195.379203,127 C195.379203,126.447715 194.931488,126 194.379203,126 L189.379203,126 C188.826918,126 188.379203,126.447715 188.379203,127 C188.379203,127.552285 188.826918,128 189.379203,128 Z M199.379203,128 L204.379203,128 C204.931488,128 205.379203,127.552285 205.379203,127 C205.379203,126.447715 204.931488,126 204.379203,126 L199.379203,126 C198.826918,126 198.379203,126.447715 198.379203,127 C198.379203,127.552285 198.826918,128 199.379203,128 Z M209.379203,128 L214.379203,128 C214.931488,128 215.379203,127.552285 215.379203,127 C215.379203,126.447715 214.931488,126 214.379203,126 L209.379203,126 C208.826918,126 208.379203,126.447715 208.379203,127 C208.379203,127.552285 208.826918,128 209.379203,128 Z M219.379203,128 L224.379203,128 C224.931488,128 225.379203,127.552285 225.379203,127 C225.379203,126.447715 224.931488,126 224.379203,126 L219.379203,126 C218.826918,126 218.379203,126.447715 218.379203,127 C218.379203,127.552285 218.826918,128 219.379203,128 Z M229.379203,128 L234.379203,128 C234.931488,128 235.379203,127.552285 235.379203,127 C235.379203,126.447715 234.931488,126 234.379203,126 L229.379203,126 C228.826918,126 228.379203,126.447715 228.379203,127 C228.379203,127.552285 228.826918,128 229.379203,128 Z M239.379203,128 L244.379203,128 C244.931488,128 245.379203,127.552285 245.379203,127 C245.379203,126.447715 244.931488,126 244.379203,126 L239.379203,126 C238.826918,126 238.379203,126.447715 238.379203,127 C238.379203,127.552285 238.826918,128 239.379203,128 Z M249.341278,128.016397 C250.951481,128.078759 252.533478,128.318601 254.066707,128.728577 C254.600247,128.871243 255.14842,128.554377 255.291086,128.020837 C255.433751,127.487297 255.116885,126.939124 254.583345,126.796458 C252.906923,126.348192 251.177618,126.086017 249.418679,126.017895 C248.866808,125.996521 248.402101,126.426574 248.380727,126.978445 C248.359354,127.530316 248.789407,127.995023 249.341278,128.016397 Z M258.517362,130.472569 C259.930358,131.218006 261.256234,132.119329 262.470333,133.158045 C262.88999,133.517081 263.521245,133.467937 263.880281,133.04828 C264.239316,132.628623 264.190172,131.997368 263.770515,131.638333 C262.443945,130.503393 260.99503,129.518428 259.450574,128.703639 C258.962097,128.445939 258.357202,128.633021 258.099503,129.121498 C257.841803,129.609975 258.028885,130.21487 258.517362,130.472569 Z M265.735801,136.646264 C266.691828,137.925801 267.503074,139.307787 268.152749,140.767428 C268.377326,141.27199 268.96841,141.498964 269.472973,141.274387 C269.977536,141.04981 270.204509,140.458725 269.979932,139.954163 C269.269602,138.358245 268.382813,136.847568 267.337977,135.449171 C267.007409,135.006742 266.380771,134.916061 265.938343,135.246629 C265.495914,135.577197 265.405233,136.203835 265.735801,136.646264 Z M269.610206,145.402431 C269.864797,146.722192 269.995979,148.070908 269.999909,149.43673 C269.999994,149.734514 269.996225,149.977881 269.98795,150.22718 C269.96963,150.77916 270.402247,151.241481 270.954228,151.259801 C271.506209,151.278122 271.968529,150.845504 271.98685,150.293524 C271.995887,150.021251 272,149.75564 271.999905,149.433556 C271.99561,147.939776 271.85228,146.466158 271.574,145.023601 C271.469389,144.481314 270.944974,144.126508 270.402687,144.231119 C269.860401,144.33573 269.505594,144.860145 269.610206,145.402431 Z M269.301275,154.959444 C268.896032,156.508441 268.318944,158.002097 267.582503,159.416445 C267.327438,159.906303 267.517775,160.510182 268.007632,160.765247 C268.49749,161.020312 269.101369,160.829975 269.356434,160.340118 C270.161749,158.793494 270.792923,157.159848 271.236156,155.46564 C271.375939,154.931338 271.056117,154.384884 270.521814,154.245102 C269.987511,154.105319 269.441057,154.425141 269.301275,154.959444 Z M264.890446,163.416028 C263.855773,164.633358 262.688546,165.733117 261.411765,166.693303 C260.970369,167.025248 260.881642,167.652166 261.213588,168.093562 C261.545534,168.534958 262.172451,168.623685 262.613847,168.291739 C264.008824,167.242666 265.28398,166.041217 266.414361,164.711282 C266.772036,164.290465 266.720848,163.659373 266.300031,163.301698 C265.879214,162.944023 265.248121,162.99521 264.890446,163.416028 Z M257.310802,169.117525 C255.858249,169.770727 254.33456,170.26087 252.762927,170.576947 C252.221484,170.685839 251.870832,171.21304 251.979723,171.754484 C252.088615,172.295927 252.615816,172.64658 253.15726,172.537688 C254.875994,172.192026 256.542515,171.655936 258.131064,170.941579 C258.634762,170.71507 258.859468,170.12312 258.632959,169.619421 C258.40645,169.115723 257.8145,168.891016 257.310802,169.117525 Z M247.861249,171 L242.861249,171 C242.308964,171 241.861249,171.447715 241.861249,172 C241.861249,172.552285 242.308964,173 242.861249,173 L247.861249,173 C248.413534,173 248.861249,172.552285 248.861249,172 C248.861249,171.447715 248.413534,171 247.861249,171 Z M237.861249,171 L232.861249,171 C232.308964,171 231.861249,171.447715 231.861249,172 C231.861249,172.552285 232.308964,173 232.861249,173 L237.861249,173 C238.413534,173 238.861249,172.552285 238.861249,172 C238.861249,171.447715 238.413534,171 237.861249,171 Z M227.861249,171 L222.861249,171 C222.308964,171 221.861249,171.447715 221.861249,172 C221.861249,172.552285 222.308964,173 222.861249,173 L227.861249,173 C228.413534,173 228.861249,172.552285 228.861249,172 C228.861249,171.447715 228.413534,171 227.861249,171 Z M217.861249,171 L212.861249,171 C212.308964,171 211.861249,171.447715 211.861249,172 C211.861249,172.552285 212.308964,173 212.861249,173 L217.861249,173 C218.413534,173 218.861249,172.552285 218.861249,172 C218.861249,171.447715 218.413534,171 217.861249,171 Z M207.861249,171 L202.861249,171 C202.308964,171 201.861249,171.447715 201.861249,172 C201.861249,172.552285 202.308964,173 202.861249,173 L207.861249,173 C208.413534,173 208.861249,172.552285 208.861249,172 C208.861249,171.447715 208.413534,171 207.861249,171 Z M197.861249,171 L192.861249,171 C192.308964,171 191.861249,171.447715 191.861249,172 C191.861249,172.552285 192.308964,173 192.861249,173 L197.861249,173 C198.413534,173 198.861249,172.552285 198.861249,172 C198.861249,171.447715 198.413534,171 197.861249,171 Z M187.861249,171 L182.861249,171 C182.308964,171 181.861249,171.447715 181.861249,172 C181.861249,172.552285 182.308964,173 182.861249,173 L187.861249,173 C188.413534,173 188.861249,172.552285 188.861249,172 C188.861249,171.447715 188.413534,171 187.861249,171 Z M177.861249,171 L172.861249,171 C172.308964,171 171.861249,171.447715 171.861249,172 C171.861249,172.552285 172.308964,173 172.861249,173 L177.861249,173 C178.413534,173 178.861249,172.552285 178.861249,172 C178.861249,171.447715 178.413534,171 177.861249,171 Z M167.861249,171 L164.506957,171 C163.979813,171 163.455044,170.981066 162.933297,170.943383 C162.382447,170.903598 161.903643,171.317898 161.863858,171.868748 C161.824074,172.419598 162.238374,172.898402 162.789224,172.938187 C163.358906,172.979332 163.931731,173 164.506957,173 L167.861249,173 C168.413534,173 168.861249,172.552285 168.861249,172 C168.861249,171.447715 168.413534,171 167.861249,171 Z M158.224474,170.068707 C156.694342,169.602361 155.224841,168.966413 153.840276,168.174393 C153.360884,167.900164 152.749954,168.066481 152.475724,168.545873 C152.201495,169.025265 152.367812,169.636196 152.847204,169.910425 C154.360985,170.776361 155.967962,171.471804 157.641403,171.981827 C158.169696,172.142837 158.728488,171.845096 158.889498,171.316802 C159.050509,170.788509 158.752767,170.229718 158.224474,170.068707 Z M149.944303,165.322518 C148.768647,164.240633 147.715761,163.031239 146.806881,161.717911 C146.492596,161.263771 145.869665,161.150395 145.415524,161.46468 C144.961384,161.778965 144.848008,162.401897 145.162293,162.856037 C146.15538,164.291044 147.305643,165.612289 148.59,166.794204 C148.996395,167.168185 149.629015,167.141908 150.002995,166.735513 C150.376976,166.329118 150.350699,165.696498 149.944303,165.322518 Z M144.548689,157.528085 C143.954054,156.051909 143.524913,154.510343 143.271315,152.926055 C143.184022,152.380713 142.671169,152.00939 142.125827,152.096684 C141.580484,152.183977 141.209162,152.69683 141.296456,153.242172 C141.573776,154.97466 142.04317,156.660825 142.693546,158.275376 C142.899905,158.78766 143.48248,159.035661 143.994763,158.829302 C144.507047,158.622943 144.755048,158.040369 144.548689,157.528085 Z",
    id: "Rectangle-22-Copy",
    fill: "#CACACA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,104.5 C20,102.886304 20.1775133,101.296463 20.5259774,99.750248 C20.6473983,99.2114759 20.3090682,98.6762837 19.7702961,98.5548628 C19.231524,98.4334419 18.6963318,98.771772 18.5749109,99.3105441 C18.1939782,101.000829 18,102.738133 18,104.5 C18,105.052285 18.4477153,105.5 19,105.5 C19.5522847,105.5 20,105.052285 20,104.5 Z M22.0912,95.2371942 C22.7802845,93.7957729 23.6287531,92.4359049 24.619121,91.182373 C24.9614981,90.7490183 24.8877462,90.1201633 24.4543914,89.7777862 C24.0210366,89.4354091 23.3921817,89.509161 23.0498046,89.9425158 C21.9675204,91.3123884 21.0401342,92.79874 20.2867898,94.3745796 C20.0485854,94.8728538 20.2594135,95.4698876 20.7576876,95.708092 C21.2559617,95.9462965 21.8529956,95.7354683 22.0912,95.2371942 Z M27.9774209,87.7834502 C29.2187943,86.7781806 30.5682103,85.9133683 32.0009727,85.2067976 C32.4963003,84.9625253 32.699821,84.3629611 32.4555488,83.8676334 C32.2112765,83.3723057 31.6117123,83.1687851 31.1163847,83.4130573 C29.5501172,84.1854665 28.075281,85.130658 26.718761,86.2291738 C26.2895595,86.5767431 26.2233834,87.2064404 26.5709528,87.6356419 C26.9185221,88.0648435 27.5482194,88.1310195 27.9774209,87.7834502 Z M36.5681385,83.568759 C38.1114673,83.2066171 39.6996933,83.0150725 41.3129528,83.0008546 C41.8652161,82.9959874 42.3089683,82.5443439 42.3041011,81.9920806 C42.2992339,81.4398173 41.8475904,80.996065 41.2953271,81.0009323 C39.5338903,81.0164561 37.7983501,81.2257672 36.1112486,81.6216453 C35.573568,81.747812 35.23997,82.2859665 35.3661367,82.8236471 C35.4923034,83.3613277 36.0304579,83.6949256 36.5681385,83.568759 Z M46.3792029,83 L51.3792029,83 C51.9314876,83 52.3792029,82.5522847 52.3792029,82 C52.3792029,81.4477153 51.9314876,81 51.3792029,81 L46.3792029,81 C45.8269181,81 45.3792029,81.4477153 45.3792029,82 C45.3792029,82.5522847 45.8269181,83 46.3792029,83 Z M56.3792029,83 L61.3792029,83 C61.9314876,83 62.3792029,82.5522847 62.3792029,82 C62.3792029,81.4477153 61.9314876,81 61.3792029,81 L56.3792029,81 C55.8269181,81 55.3792029,81.4477153 55.3792029,82 C55.3792029,82.5522847 55.8269181,83 56.3792029,83 Z M66.3792029,83 L71.3792029,83 C71.9314876,83 72.3792029,82.5522847 72.3792029,82 C72.3792029,81.4477153 71.9314876,81 71.3792029,81 L66.3792029,81 C65.8269181,81 65.3792029,81.4477153 65.3792029,82 C65.3792029,82.5522847 65.8269181,83 66.3792029,83 Z M76.3792029,83 L81.3792029,83 C81.9314876,83 82.3792029,82.5522847 82.3792029,82 C82.3792029,81.4477153 81.9314876,81 81.3792029,81 L76.3792029,81 C75.8269181,81 75.3792029,81.4477153 75.3792029,82 C75.3792029,82.5522847 75.8269181,83 76.3792029,83 Z M86.3792029,83 L91.3792029,83 C91.9314876,83 92.3792029,82.5522847 92.3792029,82 C92.3792029,81.4477153 91.9314876,81 91.3792029,81 L86.3792029,81 C85.8269181,81 85.3792029,81.4477153 85.3792029,82 C85.3792029,82.5522847 85.8269181,83 86.3792029,83 Z M96.3792029,83 L101.379203,83 C101.931488,83 102.379203,82.5522847 102.379203,82 C102.379203,81.4477153 101.931488,81 101.379203,81 L96.3792029,81 C95.8269181,81 95.3792029,81.4477153 95.3792029,82 C95.3792029,82.5522847 95.8269181,83 96.3792029,83 Z M106.379203,83 L111.379203,83 C111.931488,83 112.379203,82.5522847 112.379203,82 C112.379203,81.4477153 111.931488,81 111.379203,81 L106.379203,81 C105.826918,81 105.379203,81.4477153 105.379203,82 C105.379203,82.5522847 105.826918,83 106.379203,83 Z M116.379203,83 L121.379203,83 C121.931488,83 122.379203,82.5522847 122.379203,82 C122.379203,81.4477153 121.931488,81 121.379203,81 L116.379203,81 C115.826918,81 115.379203,81.4477153 115.379203,82 C115.379203,82.5522847 115.826918,83 116.379203,83 Z M126.341278,83.0163965 C127.951481,83.0787586 129.533478,83.3186006 131.066707,83.7285774 C131.600247,83.8712429 132.14842,83.5543766 132.291086,83.0208366 C132.433751,82.4872965 132.116885,81.9391235 131.583345,81.796458 C129.906923,81.3481923 128.177618,81.0860173 126.418679,81.0178948 C125.866808,80.9965212 125.402101,81.4265744 125.380727,81.9784454 C125.359354,82.5303164 125.789407,82.9950229 126.341278,83.0163965 Z M135.517362,85.4725692 C136.930358,86.2180056 138.256234,87.119329 139.470333,88.1580454 C139.88999,88.5170808 140.521245,88.4679372 140.880281,88.0482802 C141.239316,87.6286231 141.190172,86.9973682 140.770515,86.6383328 C139.443945,85.5033927 137.99503,84.5184276 136.450574,83.7036388 C135.962097,83.4459393 135.357202,83.6330212 135.099503,84.1214979 C134.841803,84.6099746 135.028885,85.2148698 135.517362,85.4725692 Z M142.735801,91.6462637 C143.691828,92.9258008 144.503074,94.3077872 145.152749,95.7674277 C145.377326,96.2719905 145.96841,96.4989638 146.472973,96.2743869 C146.977536,96.0498099 147.204509,95.4587253 146.979932,94.9541625 C146.269602,93.358245 145.382813,91.8475679 144.337977,90.449171 C144.007409,90.0067422 143.380771,89.9160611 142.938343,90.2466291 C142.495914,90.5771971 142.405233,91.2038349 142.735801,91.6462637 Z M146.610206,100.402431 C146.864797,101.722192 146.995979,103.070908 146.999909,104.43673 C146.999994,104.734514 146.996225,104.977881 146.98795,105.22718 C146.96963,105.77916 147.402247,106.241481 147.954228,106.259801 C148.506209,106.278122 148.968529,105.845504 148.98685,105.293524 C148.995887,105.021251 149,104.75564 148.999905,104.433556 C148.99561,102.939776 148.85228,101.466158 148.574,100.023601 C148.469389,99.481314 147.944974,99.1265078 147.402687,99.231119 C146.860401,99.3357302 146.505594,99.8601446 146.610206,100.402431 Z M146.301275,109.959444 C145.896032,111.508441 145.318944,113.002097 144.582503,114.416445 C144.327438,114.906303 144.517775,115.510182 145.007632,115.765247 C145.49749,116.020312 146.101369,115.829975 146.356434,115.340118 C147.161749,113.793494 147.792923,112.159848 148.236156,110.46564 C148.375939,109.931338 148.056117,109.384884 147.521814,109.245102 C146.987511,109.105319 146.441057,109.425141 146.301275,109.959444 Z M141.890446,118.416028 C140.855773,119.633358 139.688546,120.733117 138.411765,121.693303 C137.970369,122.025248 137.881642,122.652166 138.213588,123.093562 C138.545534,123.534958 139.172451,123.623685 139.613847,123.291739 C141.008824,122.242666 142.28398,121.041217 143.414361,119.711282 C143.772036,119.290465 143.720848,118.659373 143.300031,118.301698 C142.879214,117.944023 142.248121,117.99521 141.890446,118.416028 Z M134.310802,124.117525 C132.858249,124.770727 131.33456,125.26087 129.762927,125.576947 C129.221484,125.685839 128.870832,126.21304 128.979723,126.754484 C129.088615,127.295927 129.615816,127.64658 130.15726,127.537688 C131.875994,127.192026 133.542515,126.655936 135.131064,125.941579 C135.634762,125.71507 135.859468,125.12312 135.632959,124.619421 C135.40645,124.115723 134.8145,123.891016 134.310802,124.117525 Z M124.861249,126 L119.861249,126 C119.308964,126 118.861249,126.447715 118.861249,127 C118.861249,127.552285 119.308964,128 119.861249,128 L124.861249,128 C125.413534,128 125.861249,127.552285 125.861249,127 C125.861249,126.447715 125.413534,126 124.861249,126 Z M114.861249,126 L109.861249,126 C109.308964,126 108.861249,126.447715 108.861249,127 C108.861249,127.552285 109.308964,128 109.861249,128 L114.861249,128 C115.413534,128 115.861249,127.552285 115.861249,127 C115.861249,126.447715 115.413534,126 114.861249,126 Z M104.861249,126 L99.8612491,126 C99.3089643,126 98.8612491,126.447715 98.8612491,127 C98.8612491,127.552285 99.3089643,128 99.8612491,128 L104.861249,128 C105.413534,128 105.861249,127.552285 105.861249,127 C105.861249,126.447715 105.413534,126 104.861249,126 Z M94.8612491,126 L89.8612491,126 C89.3089643,126 88.8612491,126.447715 88.8612491,127 C88.8612491,127.552285 89.3089643,128 89.8612491,128 L94.8612491,128 C95.4135338,128 95.8612491,127.552285 95.8612491,127 C95.8612491,126.447715 95.4135338,126 94.8612491,126 Z M84.8612491,126 L79.8612491,126 C79.3089643,126 78.8612491,126.447715 78.8612491,127 C78.8612491,127.552285 79.3089643,128 79.8612491,128 L84.8612491,128 C85.4135338,128 85.8612491,127.552285 85.8612491,127 C85.8612491,126.447715 85.4135338,126 84.8612491,126 Z M74.8612491,126 L69.8612491,126 C69.3089643,126 68.8612491,126.447715 68.8612491,127 C68.8612491,127.552285 69.3089643,128 69.8612491,128 L74.8612491,128 C75.4135338,128 75.8612491,127.552285 75.8612491,127 C75.8612491,126.447715 75.4135338,126 74.8612491,126 Z M64.8612491,126 L59.8612491,126 C59.3089643,126 58.8612491,126.447715 58.8612491,127 C58.8612491,127.552285 59.3089643,128 59.8612491,128 L64.8612491,128 C65.4135338,128 65.8612491,127.552285 65.8612491,127 C65.8612491,126.447715 65.4135338,126 64.8612491,126 Z M54.8612491,126 L49.8612491,126 C49.3089643,126 48.8612491,126.447715 48.8612491,127 C48.8612491,127.552285 49.3089643,128 49.8612491,128 L54.8612491,128 C55.4135338,128 55.8612491,127.552285 55.8612491,127 C55.8612491,126.447715 55.4135338,126 54.8612491,126 Z M44.8612491,126 L41.506957,126 C40.9798128,126 40.4550439,125.981066 39.933297,125.943383 C39.3824471,125.903598 38.9036431,126.317898 38.8638584,126.868748 C38.8240736,127.419598 39.2383738,127.898402 39.7892237,127.938187 C40.3589061,127.979332 40.9317306,128 41.506957,128 L44.8612491,128 C45.4135338,128 45.8612491,127.552285 45.8612491,127 C45.8612491,126.447715 45.4135338,126 44.8612491,126 Z M35.224474,125.068707 C33.6943423,124.602361 32.2248415,123.966413 30.8402764,123.174393 C30.3608844,122.900164 29.7499536,123.066481 29.4757243,123.545873 C29.2014949,124.025265 29.3678122,124.636196 29.8472042,124.910425 C31.3609849,125.776361 32.9679621,126.471804 34.6414026,126.981827 C35.1696961,127.142837 35.7284876,126.845096 35.8894983,126.316802 C36.050509,125.788509 35.7527675,125.229718 35.224474,125.068707 Z M26.9443034,120.322518 C25.7686466,119.240633 24.7157608,118.031239 23.8068811,116.717911 C23.4925963,116.263771 22.8696646,116.150395 22.4155242,116.46468 C21.9613838,116.778965 21.8480084,117.401897 22.1622932,117.856037 C23.1553798,119.291044 24.3056428,120.612289 25.59,121.794204 C25.9963951,122.168185 26.6290146,122.141908 27.0029951,121.735513 C27.3769757,121.329118 27.3506985,120.696498 26.9443034,120.322518 Z M21.5486892,112.528085 C20.9540541,111.051909 20.5249132,109.510343 20.271315,107.926055 C20.1840216,107.380713 19.671169,107.00939 19.1258266,107.096684 C18.5804842,107.183977 18.2091622,107.69683 18.2964555,108.242172 C18.5737763,109.97466 19.0431702,111.660825 19.6935462,113.275376 C19.899905,113.78766 20.4824798,114.035661 20.9947634,113.829302 C21.507047,113.622943 21.755048,113.040369 21.5486892,112.528085 Z",
    id: "Rectangle-22-Copy-2",
    fill: "#CACACA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-4",
    stroke: "#787878",
    mask: "url(#mask-2)",
    strokeWidth: 4,
    fill: "#38B3DE",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20-Copy-2",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#F4F4F4",
    x: 71,
    y: 154,
    width: 148,
    height: 35,
    rx: 8
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3",
    stroke: "#787878",
    mask: "url(#mask-4)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy",
    stroke: "#787878",
    mask: "url(#mask-6)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-2",
    stroke: "#787878",
    mask: "url(#mask-8)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-7",
    stroke: "#787878",
    mask: "url(#mask-10)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-8",
    stroke: "#787878",
    mask: "url(#mask-12)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-21",
    stroke: "#787878",
    mask: "url(#mask-14)",
    strokeWidth: 4,
    fill: "#F4F4F4",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#F4F4F4",
    x: 71,
    y: 64,
    width: 148,
    height: 35,
    rx: 8
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3",
    stroke: "#787878",
    mask: "url(#mask-16)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy",
    stroke: "#787878",
    mask: "url(#mask-18)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-2",
    stroke: "#787878",
    mask: "url(#mask-20)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-3",
    stroke: "#787878",
    mask: "url(#mask-22)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-6",
    stroke: "#787878",
    mask: "url(#mask-24)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-21-Copy",
    stroke: "#787878",
    mask: "url(#mask-26)",
    strokeWidth: 4,
    fill: "#FFFFFF",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20-Copy",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#F4F4F4",
    x: 71,
    y: 109,
    width: 148,
    height: 35,
    rx: 8
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3",
    stroke: "#787878",
    mask: "url(#mask-28)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-27"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy",
    stroke: "#787878",
    mask: "url(#mask-30)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-29"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-2",
    stroke: "#787878",
    mask: "url(#mask-32)",
    strokeWidth: 4,
    fill: "#74BA2D",
    xlinkHref: "#path-31"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-4",
    stroke: "#787878",
    mask: "url(#mask-34)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-33"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-5",
    stroke: "#787878",
    mask: "url(#mask-36)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-35"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-10",
    stroke: "#787878",
    mask: "url(#mask-38)",
    strokeWidth: 4,
    fill: "#E0E0E0",
    xlinkHref: "#path-37"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-9",
    stroke: "#787878",
    mask: "url(#mask-40)",
    strokeWidth: 4,
    fill: "#E0E0E0",
    xlinkHref: "#path-39"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-12",
    stroke: "#787878",
    mask: "url(#mask-42)",
    strokeWidth: 4,
    fill: "#E0E0E0",
    xlinkHref: "#path-41"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-11",
    stroke: "#787878",
    mask: "url(#mask-44)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-43"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-16",
    stroke: "#787878",
    mask: "url(#mask-46)",
    strokeWidth: 4,
    fill: "#E0E0E0",
    xlinkHref: "#path-45"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-15",
    stroke: "#787878",
    mask: "url(#mask-48)",
    strokeWidth: 4,
    fill: "#E0E0E0",
    xlinkHref: "#path-47"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-14",
    stroke: "#787878",
    mask: "url(#mask-50)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-49"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy-13",
    stroke: "#787878",
    mask: "url(#mask-52)",
    strokeWidth: 4,
    fill: "#E0E0E0",
    xlinkHref: "#path-51"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-21-Copy-2",
    stroke: "#787878",
    mask: "url(#mask-54)",
    strokeWidth: 4,
    fill: "#FFFFFF",
    xlinkHref: "#path-53"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-21-Copy-3",
    stroke: "#787878",
    mask: "url(#mask-56)",
    strokeWidth: 4,
    fill: "#FFFFFF",
    xlinkHref: "#path-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.127319,44.4570612 C178.075657,43.8326811 178.041182,43.2702598 178,43 C178.133333,25.3125 192.565104,11 210,11 C222.130661,11 232.465236,17.2479454 237.938311,26.7023787 C241.5237,23.7443036 246.062885,22 251,22 C262.59798,22 272,31.6258779 272,44 C272,47.3352877 271.191552,50.5202498 269.756352,53.3562576 C277.680369,57.6990261 283,65.7264028 283,75 C283,88.25 272.160417,99 259,99 L191,99 C190.826571,99 190.653555,98.9985836 190.480963,98.9957611 C190.320926,98.998583 190.160601,99 190,99 C173.759885,99 161,86.2401154 161,71 C161,59.0114689 167.953452,48.9194768 178.127319,44.4570612 Z",
    id: "Combined-Shape",
    stroke: "#787878",
    strokeWidth: 2,
    fill: "#FFEEDA"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-3-Copy",
    stroke: "#787878",
    mask: "url(#mask-58)",
    strokeWidth: 4,
    fill: "#FFB132",
    xlinkHref: "#path-57"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3-Copy-2",
    stroke: "#787878",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5,5,5,5",
    fill: "#FFFFFF",
    cx: 222,
    cy: 62,
    r: 24
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "#787878",
    mask: "url(#mask-60)",
    strokeWidth: 2,
    xlinkHref: "#path-59"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-Copy",
    stroke: "#787878",
    mask: "url(#mask-62)",
    strokeWidth: 2,
    transform: "translate(215.126793, 68.407764) rotate(-122.000000) translate(-215.126793, -68.407764) ",
    xlinkHref: "#path-61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#38B3DE",
    fillRule: "evenodd",
    xlinkHref: "#path-63"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#787878",
    mask: "url(#mask-64)",
    strokeWidth: 4,
    xlinkHref: "#path-63"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerTimedOut);
export default __webpack_public_path__ + "static/media/server-timed-out.502d5034a42e1d732373ac60b2477a52.svg";
export { ForwardRef as ReactComponent };